import { gql } from '@apollo/client';
import { BLOCKED_TEMPLATE_CONTENT_BUILD_EMAIL_PREVIEW_FRAGMENT } from './BlockedTemplateContentBuildEmailPreview.fragment';

export const GET_BLOCKED_PREVIEWS_QUERY = gql`
    query GetBlockedTemplateContentBuildEmailPreviews($after: String, $first: Int) {
        admin {
            id
            blockedTemplateContentBuildEmailPreviews(after: $after, first: $first) {
                edges {
                    node {
                        id
                        ...BlockedTemplateContentBuildEmailPreviewFragment
                    }
                }
                pageInfo {
                    hasNextPage
                    endCursor
                }
            }
        }
    }
    ${BLOCKED_TEMPLATE_CONTENT_BUILD_EMAIL_PREVIEW_FRAGMENT}
`;
